<template>
  <div class="container-fluid">
    <page-header 
      class="mt-4 mt-md-0 mt-sm-4"
      :page="headerConfig"
    />
    
    <filter-manager
      v-model="filter"
      :filters="filterConfig"
      :display-advanced="false"
      @search="handleSearch"
    />

    <custom-separator
      class="pt-3 my-4"
      text="Resultados"
    />

    <custom-result-not-found
      v-if="!filteredApplications.length"
      text="No hay enlaces disponible."
    />

    <ApplicationResultRow 
      v-for="app in filteredApplications"
      :key="app.name"
      :id="app.id"
      :name="app.name"
      :updated-date="app.updatedDate"
      :updated-by="app.updatedBy"
      :icon-src="app.iconSrc"
      :icon-background-color="app.textColor"
      :active="app.active"
      @edit="handleEdit"
      @toggle="handleToggleStatus"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import ApplicationResultRow from './components/ApplicationResultRow.vue';

import alert from "@/mixin/alert.mixin";
import { unRegisterMixin } from '@/mixin/storeGenerator';

import { getList, toggle } from "@/services/operations/public-portal-application";

export default {
  name: 'SearchApplications',
  mixins: [alert, unRegisterMixin],
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    ApplicationResultRow
  },
  data() {
    return {
      headerConfig: {
        title: 'Manejo de Enlaces del Portal Público',
        icon: 'fas fa-calculator',
        routes: ['Inicio', 'Operaciones', 'Manejo de Enlaces del Portal Público'],
      },
      filter: {
        portal: null,
        status: null,
      },
      applications: [],
      filteredApplications: [],
    };
  },
  computed: {
    filterConfig() {
      return [
        {
          name: 'portal',
          component: 'CustomDropDown',
          class: 'col-md-6',
          initialValue: null,
          options: this.applications.map(portal => ({
            id: portal.id,
            name: portal.name
          })),
          placeholder: 'Portal',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          class: 'col-md-6',
          initialValue: null,
          options: [
            { id: 1, name: 'Activo' },
            { id: 2, name: 'Inactivo' },
          ],
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
        },
      ]
    },
  },
  methods: {
    async fetchApplications() {
      let response = await getList();
      this.applications = response.data;
      this.filteredApplications = [...this.applications];
    },
    handleSearch(data) {
      this.filteredApplications = [...this.applications];

      if (data.portal !== null) {
        this.filteredApplications = this.applications.filter(app => app.id == data.portal.id);
      }

      if (data.status !== null) {
        this.filteredApplications = this.filteredApplications.filter(app => data.status.id == 1 ? app.active : !app.active);
      }
    },
    handleEdit(applicationId) {
      this.$router.push({
        name: 'operationPublicPortalEditApplication',
        params: { id: applicationId },
      });
    },
    async handleToggleStatus(id) {
      let application = this.applications.find(app => app.id == id);

      let response = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro(a) que desea ${application.active ? 'inactivar' : 'reactivar'} el portal ${application.name}?`,
        "Si",
        "No"
      );

      if (!response) return;

      await toggle(id);      
      application.active = !application.active;
    },
  },
  async mounted() {
    await this.fetchApplications();
  }
};
</script>